import { useSession } from './useSession';

export const useProfile = (pharmacyId?: string) => {
  const { session } = useSession(pharmacyId);

  return session?.profile;
};
